import Icons from "../../assets/icon/index";
import { HoverButton, Stepper, Newlogo } from "../../components";
import { FormStep } from "../index";
import Functions from "./index.function";
const TalentRegister = () => {
  const {
    steps,
    currentStep,
    setCurrentStep,
    completedSteps,
    handleSubmit,
    onSubmit,
    register,
    watch,
    control,
    setValue,
    errors,
    links,
    setLinks,
    selectedPlatform,
    setSelectedPlatform,
    linksErrors,
    setLinksErrors,
    select,
    setSelect,
    setCountryCode,
    setCca2,
    isOfScreen,
    setIsOfScreen,
    otherLanguageId,
    otherExperienceId,
    loadingToapi,
    isModalOpen,
    setModalOpen,
  } = Functions();

  return (
    <div
      className={`bg-primary h-screen scroll-container xs:py-5 sm:py-8 lg:py-10`}
    >
      <div className="xs:pb-5 sm:pb-8 lg:pb-10 max-w-7xl lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto">
        <div className="flex justify-center items-center xs:py-5">
          <Newlogo />
        </div>
      </div>
      <div className="max-w-7xl lg:px-5 xl:px-10 sm:px-5 xs:px-3 m-auto">
        <div className="flex justify-center items-center flex-col relative lg:py-8">
          <h1 className="uppercase text-secondary font-unboundedBold lg:text-3xl lg:leading-tight">
            Create Account (Talent)
          </h1>
        </div>
        <Stepper
          steps={steps}
          currentStep={currentStep}
          completedSteps={completedSteps}
        />
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormStep
            step={currentStep}
            register={register}
            watch={watch}
            select={select}
            links={links}
            setLinks={setLinks}
            selectedPlatform={selectedPlatform}
            setSelectedPlatform={setSelectedPlatform}
            linksErrors={linksErrors}
            setLinksErrors={setLinksErrors}
            setSelect={setSelect}
            control={control}
            setValue={setValue}
            errors={errors}
            setCountryCode={setCountryCode}
            setCca2={setCca2}
            isOfScreen={isOfScreen}
            otherLanguageId={otherLanguageId}
            otherExperienceId={otherExperienceId}
          />
          <div
            className={`flex items-center xs:gap-x-3  xs:pt-5 sm:pt-6 sm:gap-x-6 xs:w-full sm:w-[90%] lg:w-[60%] mx-auto ${
              currentStep > 0 ? "justify-between" : "justify-center"
            } `}
          >
            {currentStep > 0 && (
              <button
                onClick={() => setCurrentStep((prev) => prev - 1)}
                type={"button"}
                className={`group xs:h-10 sm:h-12 border border-secondary xs:w-1/2 sm:w-1/2 lg:w-1/2 cursor-pointer bg-cover flex lg:h-12 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md`}
              >
                <p
                  className={`text-secondary font-onestSemiBold sm:text-sm lg:text-lg`}
                >
                  Back
                </p>
              </button>
            )}
            <HoverButton
              extraClasses={`group xs:h-10 sm:h-12 xs:w-1/2 sm:w-1/2 lg:w-1/2 cursor-pointer bg-cover flex lg:h-12 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform ${
                loadingToapi ? "" : "hover:scale-105 hover:shadow-md"
              }`}
              BtnTitle={
                loadingToapi ? (
                  <div className="flex justify-center items-center">
                    <div className="animate-spin rounded-full border-t-2 border-b-2 border-secondary h-12 w-12 lg:w-10 lg:h-10  md:w-8 md:h-8 sm:w-10 sm:h-10 xs:w-8 xs:h-8"></div>
                  </div>
                ) : currentStep === steps.length - 1 ? (
                  "Submit"
                ) : (
                  "Next"
                )
              }
              disabled={loadingToapi}
              type={"submit"}
              BtnTitleClasses={`text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform ${
                loadingToapi
                  ? ""
                  : "group-hover:scale-110 group-hover:text-primary"
              }`}
            />
          </div>
        </form>
      </div>
      {isModalOpen && (
        <div className="fixed top-0 left-0 w-full h-screen bg-[#0d0d0def] flex justify-center items-center xs:p-5 sm:p-10 lg:p-16 z-40">
          <div className="xs:w-full sm:w-[85%] flex justify-center items-center sm:gap-7 lg:gap-8 xs:flex-col xs:gap-y-4 lg:w-[80%] xl:w-[60%] bg-[#151515] xs:p-5 sm:p-8 lg:p-10 rounded-3xl h-full">
            {/* On-Screen Selection */}
            <div
              className="xs:w-52 xs:h-48 sm:w-52 sm:h-44 lg:w-64 rounded-3xl flex justify-center items-center flex-col lg:h-60 cursor-pointer transition-all duration-300 transform hover:scale-105 hover:shadow-md"
              style={{ backgroundColor: "#FC3636" }}
              onClick={() => {
                setModalOpen(false);
                setIsOfScreen(false);
              }}
            >
              <img
                src={Icons.rollTALENTIcons}
                className="w-[25%]"
                alt="user roll icon"
              />
              <div className="xs:pt-1 lg:pt-2">
                <h3 className="text-secondary text-center uppercase font-montserratSemiBold xs:text-sm lg:text-xl">
                  On screen
                </h3>
              </div>
            </div>

            {/* Off-Screen Selection */}
            <div
              className="xs:w-52 xs:h-48 sm:w-52 sm:h-44 lg:w-64 rounded-3xl flex justify-center items-center flex-col lg:h-60 cursor-pointer transition-all duration-300 transform hover:scale-105 hover:shadow-md"
              style={{ backgroundColor: "#FC3636" }}
              onClick={() => {
                setModalOpen(false);
                setIsOfScreen(true);
              }}
            >
              <img
                src={Icons.rollTALENTIcons}
                className="w-[25%]"
                alt="user roll icon"
              />
              <div className="xs:pt-1 lg:pt-2">
                <h3 className="text-secondary text-center uppercase font-montserratSemiBold xs:text-sm lg:text-xl">
                  Off screen
                </h3>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default TalentRegister;
